<template>
    <div>
        <div class="input">
            <input type="text" placeholder="Rechercher une personne" @input="search" id="instantInput">
            <div class="results" v-if="resultOpen" v-click-outside="closeSearch">
                <div v-if="!error">
                    <user-inline @close="closeSearch" :search="true" v-for="user in users"
                                 :user="user"></user-inline>
                </div>

                <div v-else>
                    {{errorMessage}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ClickOutside from 'vue-click-outside'

    import Pill from "../a-elements/pill";
    import UniButton from "../a-elements/UniButton";
    import UniCtaLink from "../a-elements/UniCtaLink";
    import UserInline from "../b-patterns/userInline";
    import {mapGetters} from "vuex";

    export default {
        name: "instantSearch",
        components: {UserInline, UniCtaLink, UniButton, Pill},
        computed: {
            ...mapGetters(['currentYear'])
        },
        data() {
            return {
                isMobile: true,
                style: false,
                resultOpen: false,
                users: [],
                error: false,
                errorMessage: "Aucun utilisateur n'a été trouvé."
            }
        },
        directives: {
            ClickOutside
        },
        methods: {
            search(e) {

                if (e.target.value.length > 3) {
                    this.users = []
                    this.$searchUser(e.target.value)
                        .then(data => {
                            this.error = false
                            let u = []
                            data.forEach(family => {

                                if (!family.is_admin) {
                                    family.users.forEach(user => {
                                        user.payments = family.payments.filter(p => p.year_id === this.currentYear.id)
                                        u.push(user)
                                    })
                                }


                            })
                            this.users = u
                            this.users.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            })

                        })
                        .catch(error => {
                            this.error = true
                        })
                    this.resultOpen = true
                    if (this.isMobile && !this.style) {
                        this.$nextTick(() => {
                            let div = document.querySelector('.results')
                            let left = div.getBoundingClientRect().left
                            div.style.left = "-" + left + "px"
                            this.style = true
                        })
                    }
                } else {
                    this.resultOpen = false
                }
            },
            closeSearch() {
                this.resultOpen = false
                document.querySelector('#instantInput').value = ''

            },
            isUserOnMobile() {
                const width = window.innerWidth || document.documentElement.clientWidth ||
                    document.body.clientWidth
                this.isMobile = width < 768
            }
        },
        mounted() {
            this.isUserOnMobile()
        }
    }
</script>

<style scoped lang="scss">
    .input {
        position: relative;
    }

    input {
        background: var(--color-grey-light-2);
        border-radius: var(--radius-default);
        color: var(--color-black);
        padding: 12px 16px;
        border: none;
        width: 200px;
        outline: none;

        &::placeholder {
            color: var(--color-black);
        }
    }

    .results {
        width: 100vw;
        padding: 8px;
        margin-top: .5rem;
        position: absolute;
        background: var(--color-white);
        // border: 1px solid var(--color-grey-light-2);
        border-radius: var(--radius-big);
        box-shadow: var(--shadow-s);
    }

    .container {
        margin-top: .5rem;
        width: 100%;
        border-radius: var(--radius-big);
        background: var(--color-grey-light-2);
        color: var(--color-black);
        padding: 8px 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        > div {
            margin-right: 1rem;

            &:last-child {
                margin-right: 0;
            }

            > button {
                min-width: 130px;
            }

            small {
                color: var(--color-grey-light-1);
            }
        }

        &:first-child {
            margin-top: 0;
        }
    }

    @include screen-m {
        input {
            width: 300px;
        }

        .results {
            width: auto;
            min-width: 900px;
            padding-top: 16px;
        }
    }

</style>
